import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 72 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M.195 26.623l12.246-13.17L.195 0h12.246l12.073 13.3-12.16 13.323H.196z",
  fill: "#C8B600"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.93 26.623l12.245-13.17L22.93 0h12.245l12.074 13.3-12.16 13.323H22.93zM47.25 26.623l12.245-13.17L47.25 0h12.245l12.053 13.3-12.139 13.323H47.25z",
  fill: "#C8B600"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}